module.exports = __webpack_public_path__ + "static/media/comics.68f5f2a5.webp";